import type { SxProps, Theme } from '@mui/material/styles';

export const containerStyles: SxProps = {
  position: 'relative',
  px: 2,
  py: 1,
  transition: 'background-color 0.2s',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  '.edit-icon, .close-icon, .icon-container': {
    visibility: 'hidden',
  },

  '&:hover': {
    '.edit-icon, .close-icon, .icon-container': {
      visibility: 'visible',
    },

    backgroundColor: 'action.hover',
  },
};

export const headerRowStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
};

export const closeIconStyles: SxProps = {
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)',
};

export const boxIconContainerStyles: SxProps<Theme> = {
  position: 'absolute',
  right: 0,
  paddingRight: 2,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  gap: 0.5,
  justifyContent: 'flex-end',
  alignItems: 'center',
  background: theme => `linear-gradient(270deg, ${theme.palette.background.antiflashWhite} 69.09%, transparent 100%)`,
  width: '110px',
  height: '100%',
};
